import React from 'react';
import { Button } from './ui/Button';
import { Phone } from 'lucide-react';
export function CtaBanner() {
  return <section className="py-16 bg-gold" data-id="element-1">
      <div className="container px-4 md:px-6 mx-auto text-center" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-3">
          Ready for Spotless Windows?
        </h2>
        <p className="text-xl text-navy/80 mb-8 max-w-2xl mx-auto font-medium" data-id="element-4">
          Book your free estimate today — fast, friendly, and affordable.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-5">
          <Button variant="primary" size="lg" className="w-full sm:w-auto min-w-[200px] text-lg" data-id="element-6">
            Get Your Free Quote
          </Button>
          <a href="tel:4805550123" className="flex items-center justify-center gap-2 px-8 py-4 rounded-md font-bold text-navy border-2 border-navy hover:bg-navy hover:text-white transition-colors w-full sm:w-auto min-w-[200px]" data-id="element-7">
            <Phone className="h-5 w-5" data-id="element-8" />
            (480) 555-0123
          </a>
        </div>
      </div>
    </section>;
}